<template>
    <div>
        <footer class="bg-live-orange">	
            <div class="container flex items-center max-w-6xl px-2 py-8 mx-auto">

                <div class="flex flex-wrap items-center w-full mx-auto">
                    <div class="flex justify-center w-full font-extrabold text-white md:w-1/2 md:justify-start">
                        <a class="text-gray-900 no-underline hover:text-gray-900 hover:no-underline" href="https://druckundwerte.de" target="_blank">
                            <span class="text-base text-white hover:text-live-blue">Druck und Werte GmbH</span>
                        </a>
                    </div>
                    <div class="flex content-center justify-between w-full pt-2 md:w-1/2 md:justify-end">
                        <ul class="flex items-center justify-center flex-1 list-reset md:flex-none">
                        <li>
                            <router-link :to="{ name: 'Imprint' }" class="inline-block px-3 py-2 text-white no-underline hover:text-live-blue hover:underline">Impressum / Datenschutz</router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'UserAgreement' }" class="inline-block px-3 py-2 text-white no-underline hover:text-live-blue hover:underline">Nutzungsvereinbarung</router-link>
                        </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>